"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 2.68v-1h3.191v8.973H16v1H2.191V2.68H0Zm9.453.214v-1h6.377v8.014H4V1.894h4.408v2.92h2.964v-1.92H9.453Zm2.919 0v2.92H7.407v-2.92H5V8.91h9.831V2.894h-2.459ZM5.775 13.32c-.584 0-1.06-.475-1.06-1.06h-1c0 1.136.924 2.06 2.06 2.06a2.062 2.062 0 0 0 2.059-2.06h-1a1.06 1.06 0 0 1-1.06 1.06Zm6.34-1.06a1.061 1.061 0 0 0 2.12 0h1c0 1.136-.925 2.06-2.06 2.06a2.062 2.062 0 0 1-2.06-2.06h1Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 3.837V2.712h4.609v13.454H24v1.124H3.484V3.837H0Zm14.372.32V3.032h9.187v11.643H6.195V3.032h6.236V7.41h4.818V4.157h-2.877Zm4.002 0v4.377h-7.069V4.157H7.321v9.393h15.113V4.157h-4.06ZM8.67 20.163c-.98 0-1.776-.796-1.776-1.775H5.77c0 1.599 1.301 2.9 2.9 2.9 1.6 0 2.901-1.301 2.901-2.9h-1.125c0 .979-.796 1.775-1.775 1.775Zm9.317-1.775c0 .979.797 1.775 1.776 1.775s1.776-.796 1.776-1.775h1.125c0 1.599-1.302 2.9-2.901 2.9a2.904 2.904 0 0 1-2.9-2.9h1.124Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 5.116v-1.5h6.145v17.939H32v1.499H4.645V5.116H0Zm19.163.427v-1.5h12.249v15.523H8.26V4.043h8.314V9.88h6.424V5.543h-3.836Zm5.336 0v5.836h-9.425V5.543H9.762v12.523h20.15V5.543H24.5ZM11.56 26.884a2.37 2.37 0 0 1-2.368-2.367h-1.5a3.872 3.872 0 0 0 3.868 3.867 3.872 3.872 0 0 0 3.867-3.867h-1.5a2.37 2.37 0 0 1-2.367 2.367Zm12.424-2.367a2.37 2.37 0 0 0 2.367 2.367 2.37 2.37 0 0 0 2.368-2.367h1.5a3.872 3.872 0 0 1-3.868 3.867 3.872 3.872 0 0 1-3.867-3.867h1.5Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 7.488V5.613h9.032v26.905H48v1.875H7.157V7.488H0Zm14.456 19.8h30.597V8.13h-8.494v8.752h-13.76V8.13h-8.343v19.157ZM28.931 6.254h17.997v22.907H12.581V6.255h12.093v8.752h10.01V8.13H28.93V6.255ZM17.343 40.512a3.742 3.742 0 0 1-3.739-3.738H11.73a5.62 5.62 0 0 0 5.613 5.613 5.62 5.62 0 0 0 5.613-5.613H21.08a3.742 3.742 0 0 1-3.738 3.738Zm18.446-3.738a3.742 3.742 0 0 0 3.738 3.738 3.742 3.742 0 0 0 3.738-3.738h1.875a5.62 5.62 0 0 1-5.613 5.613 5.62 5.62 0 0 1-5.613-5.613h1.875Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 9.984v-2.5h12.043v35.874H64v2.5H9.543V9.984H0Zm19.275 26.399H60.07V10.84H48.745v11.67H30.399V10.84H19.275v25.543Zm19.3-28.043H62.57v30.543H16.775V8.34h16.124v11.67h13.346v-9.17h-7.67v-2.5ZM23.123 54.016a4.99 4.99 0 0 1-4.984-4.984h-2.5c0 4.127 3.358 7.484 7.484 7.484 4.127 0 7.484-3.357 7.484-7.484h-2.5a4.99 4.99 0 0 1-4.984 4.984Zm24.596-4.984a4.99 4.99 0 0 0 4.984 4.984 4.99 4.99 0 0 0 4.984-4.984h2.5c0 4.127-3.358 7.484-7.484 7.484-4.126 0-7.484-3.357-7.484-7.484h2.5Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconWholesale = function IconWholesale(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Wholesale' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Wholesale"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconWholesale.sizes = [16, 24, 32, 48, 64];
IconWholesale.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconWholesale;
exports.default = _default;